import { useQuery } from "@tanstack/react-query";
import FETCHER from "./_fetcher";
import { IResponse } from "types/api";
import { ICategoryList } from "types/category";

export const getCategory = async () => {
  try {
    const result = await FETCHER.get<IResponse<ICategoryList[]>>(
      `/category?page=1&limit=200`
    );
    return result.data;
  } catch (e) {
    console.log(e);
  }
};
export const useGetCategory = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["getCategory"],
    queryFn: () => getCategory(),
    retry: false,
  });
  return {
    categoryList: data?.items,
    isLoading,
  };
};
export const getSubcategory = async (parentId: string) => {
  try {
    const result = await FETCHER.get<ICategoryList>(`/category/${parentId}`);
    return result.data;
  } catch (e) {
    console.log(e);
  }
};
export const useGetSubcategory = (parentId: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["getSubcategory", parentId],
    queryFn: () => getSubcategory(parentId),
    retry: false,
    enabled: !!parentId, // Only fetch when parentId is provided
  });
  return {
    categoryList: data,
    isLoading,
  };
};
